import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import { withError } from '@/react-tools/react-query';

import { AdditionalFunctionality } from '../types';
import { buildUrl } from '../settings.service';

import { queryKeys } from './queryKeys';

type AdditionalFunctionalityFeaturesSettings = {
  additionalFunctionality: AdditionalFunctionality;
};

export function useAdditionalFunctionalitySettings<
  T = AdditionalFunctionalityFeaturesSettings,
>(
  select?: (settings: AdditionalFunctionalityFeaturesSettings) => T,
  enabled = true
) {
  return useQuery(
    queryKeys.additionalFunctionality(),
    getAdditionalFunctionalitySettings,
    {
      select,
      enabled,
      staleTime: 50,
      ...withError('Unable to retrieve additional functionality settings'),
    }
  );
}

async function getAdditionalFunctionalitySettings() {
  try {
    const { data } = await axios.get<AdditionalFunctionalityFeaturesSettings>(
      buildUrl('additional_functionality')
    );
    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to retrieve additional functionality settings'
    );
  }
}
